import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import '../../css/InstantScreens/Instant.css';
import { ValidatorUtils } from '../../utils';

import { Routes as routes, History as history } from '../../navigation';
import { UserActions, NavigationActions, ContextActions, InstantActions } from '../../actions';
import { Button, Input, Line, PhoneInput } from  '../../components'

class InstantSignUpScreen extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: '',
      confirm_email: '',
      password: '',
      confirm_password: '',
      practice_name: '',
      phone_number: '',
      street_address: '',
      city: '',
      state: '',
      zipcode: '',
      validation: {},
      loading: false,
      tos: false,
    }
  }

  componentDidMount() {

  }

  rendeInfoInputs = () => {
    return <div className='flex-container-column'>

      <div className='flex-container-row' style={{ marginLeft: 15, marginTop: 10 }}>
        <span className='fas fa-user-md' style={{ fontSize: 16, color: '#1dc2ff', marginTop: 2 }}></span>
        <span style={{ fontWeight: 'bold', marginLeft: 5 }}>Practice Access</span>
      </div>

      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="Email"
               value={this.state.email}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['email']}
               style={{ flex: 1, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, email: event.target.value }) }}
              />
        <Input placeholder="Confirm Email"
               value={this.state.confirm_email}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['confirm_email']}
               style={{ flex: 1, marginLeft: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, confirm_email: event.target.value }) }}
              />
      </div>

      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="Password"
               value={this.state.password}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['password']}
               style={{ flex: 1, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, password: event.target.value }) }}
               type='password'
              />
        <Input placeholder="Confirm Password"
               value={this.state.confirm_password}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['confirm_password']}
               style={{ flex: 1, marginLeft: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, confirm_password: event.target.value }) }}
               type='password'
              />
      </div>
      <span style={{ fontSize: 12, marginTop: 2, marginLeft: 17, color: 'grey' }}>Passwords must be 8 characters or more and contain a lowercase, upper case, a number, and a special character including @$!?%*</span>

      <div className='flex-container-row' style={{ marginLeft: 15, marginTop: 15 }}>
        <span className='fas fa-notes-medical' style={{ fontSize: 16, color: '#1dc2ff', marginTop: 2 }}></span>
        <span style={{ fontWeight: 'bold', marginLeft: 5 }}>Practice Account Info</span>
      </div>

      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="Practice Name"
               value={this.state.practice_name}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['practice_name']}
               style={{ width: 180 }}
               onChange={ (event) => { this.setState({ ...this.state, practice_name: event.target.value }) }}
              />
      </div>

      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="Street Address"
               value={this.state.street_address}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['street_address']}
               style={{ flex: 1 }}
               onChange={ (event) => { this.setState({ ...this.state, street_address: event.target.value }) }}
              />
      </div>

      <div className='flex-container-row' style={{ paddingLeft: 15, paddingRight: 15, marginTop: 5 }}>
        <Input placeholder="City"
               value={this.state.city}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['city']}
               style={{ width: 180, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, city: event.target.value }) }}
              />
        <Input placeholder="State"
               value={this.state.state}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['state']}
               style={{ width: 80, marginRight: 5 }}
               onChange={ (event) => { this.setState({ ...this.state, state: event.target.value }) }}
              />
        <Input placeholder="Zipcode"
               value={this.state.zipcode}
               className='instant-input-default'
               invalid={this.state.validation.fields && this.state.validation.fields['zipcode']}
               style={{   width: 100  }}
               onChange={ (event) => { this.setState({ ...this.state, zipcode: event.target.value }) }}
              />
      </div>

      <div className='flex-container-column' style={{ paddingLeft: 15, paddingTop: 5 }}>
        <PhoneInput value={this.state.phone_number}
                    style={{ fontSize: 13 }}
                    containerStyle={{ width: 265 }}
                    invalid={this.state.validation.fields && this.state.validation.fields['phone_number']}
                    onChange={ (phone_number) => { this.setState({ ...this.state, phone_number: phone_number }) }}/>
      </div>

    </div>
  }

  renderErrorMessages = () => {
    let error_messages = this.state.validation && this.state.validation.errors ? this.state.validation.errors : [];

    let error_message_rows = error_messages.map((message, index) => {
      return <span style={{ color: '#F71735', fontSize: 12 }} key={index}>{ message }</span>
    })
    return <div className='flex-container-column' style={{ alignItems: 'center', marginTop: 10 }}>
      <span className='flex-container-column' style={{ }}>
        { error_message_rows }
      </span>
    </div>
  }

  render() {
    return (
      <div className="flex-container flex-container-column" style={{  justifyContent: 'center', alignItems: 'center' }}>

      <div className='flex-container-column' style={{ marginTop: 30, paddingBottom: 10, alignItems: 'flex-end', width: 400 }}>
        <div className='instant-join-session-button'
             onClick={ () => {
               const screen_props = {
                 is_no_nav: true
               }
               history.push({ pathname: routes.INSTANT_HELP, state: { props: screen_props } })
             }}>
          <span className='fas fa-info-circle' style={{ fontSize: 16, marginRight: 8 }}/>
          <span style={{ fontWeight: 'bold', fontSize: 14 }}>FAQs</span>
        </div>
      </div>

        <div className='instant-sign-up-container flex-container-column' style={{ marginTop: 0 }}>

          <div className='flex-container-row' style={{ justifyContent: 'space-between', padding: 10, paddingLeft: 15, paddingRight: 15, alignItems: 'center' }}>
            <span className='fas fa-arrow-circle-left instant-back-button'
                  style={{ fontSize: 30 }}
                  onClick={ () => {
                    history.goBack();
                  }} />
            <div className='flex-container-column' style={{ alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: 22 }}>Practice Sign Up</span>
              <span style={{ width: 260, height: 2, borderRadius: 2, backgroundColor: '#1dc2ff' }}></span>
              <span style={{ fontSize: 13, color: '#1dc2ff' }}>Please only create one account per practice</span>
            </div>
            <span className='fas fa-arrow-circle-left' style={{ fontSize: 30, color: 'white' }}></span>
          </div>

          { this.rendeInfoInputs() }

          { this.renderErrorMessages() }

          <div className='flex-container-row' style={{ alignItems: 'center', paddingLeft: 15, paddingRight: 15 }}>
            { /* <span className={  this.state.tos ? 'fas fa-check-circle instant-tos-buttons' : 'far fa-circle instant-tos-buttons'}
                  style={{ marginRight: 8, fontSize: 20, color: this.state.tos ? '#1dc2ff' : '' }}
                  onClick={ () => {
                    this.setState({ ...this.state, tos: !this.state.tos })
                  }}></span> */ }
            <span style={{ fontSize: 13, color: 'grey', marginTop: 5, marginBottom: 5 }}>
              By creating your TeleTails Instant account you are agreeing to our
              <a className="tos-link" style={{ color: '#1dc2ff' }} target="_blank" href="https://www.teletails.com/tos"> Terms & Conditions</a> and
              <a className="tos-link" style={{ color: '#1dc2ff' }} target="_blank" href="https://www.teletails.com/tos"> Privacy Policy</a>.
            </span>
          </div>

          <div className='flex-container-row' style={{ paddingTop: 10, justifyContent: 'center' }}>
            <Button value='Create Account'
                    style={{ paddingRight: 40, paddingLeft: 40 }}
                    loading={this.state.loading}
                    onClick={ () => {
                      this.processSignUpInputs();
                    }}/>
          </div>

        </div>
      </div>
    );
  }

  processSignUpInputs = () => {

    let sign_up_data = {
      email: this.state.email,
      password: this.state.password,
      practice_name: this.state.practice_name,
      phone: this.state.phone_number,
      location_name: this.state.practice_name,
      street_address: this.state.street_address,
      address: this.state.street_address,
      city: this.state.city,
      state: this.state.state,
      zipcode: this.state.zipcode,
      type: 'PROVIDER',
      is_instant: true,
    }

    let validator_obj = Object.assign({}, sign_up_data);

    validator_obj.confirm_email    = this.state.confirm_email;
    validator_obj.confirm_password = this.state.confirm_password;

    let validation = ValidatorUtils.validate('instantSignUp', validator_obj);

    if (!validation.valid) {
      this.setState({ ...this.state, validation: validation, loading: false });
      return;
    } else {
      this.setState({ ...this.state, validation: validation, loading: true });
    }

    this.props.instantActions.createInstantAccount(sign_up_data, this.registerCallback);
  }

  registerCallback = () => {
    this.setState({ ...this.state, loading: false });
  }

}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    context: state.context,
    loading: state.loading,
    notifications: state.notifications,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    contextActions: bindActionCreators(
     { ...ContextActions }, dispatch),
    instantActions: bindActionCreators(
     { ...InstantActions }, dispatch),
    userActions: bindActionCreators(
     { ...UserActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(InstantSignUpScreen)
